import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Images } from '@/assets';
import { colors } from '@/theme/colors';
import CommonTitle from '@/components/title/CommonTitle';
import AddressAndContact from './AddressAndContact';
import { fonts } from '@/theme/fonts';
import { MultiLineText } from '@/components/text/MultiLineText';

const CustomerCenterPage = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <CommonTitle
        imgUrl={Images.NavCustomerCenterIcon}
        title={t('customerCenter')}
      />
      <ContentsSection>
        <TopSection>
          <LeftSection>
            <AddressAndContact />
          </LeftSection>
          <RightSection>
            <QRCodeImg
              src={Images.QrCodeSctionImg}
              alt="customer-center-qr-code"
            />
            <InfoWrap>
              <Desc>
                {t('scanTheQrCodeToChatWithUsOnYourFavoriteMessengerApp')}
              </Desc>
              <NubmerSection>
                <NumberWrap>
                  <NumImg src={Images.Number1} alt="customer-center-number-1" />
                  <div>{t('scanTheQRCodeUsingYourPhonesCamera')}.</div>
                </NumberWrap>
                <NumberWrap>
                  <NumImg src={Images.Number2} alt="customer-center-number-2" />
                  <div>
                    {t('tapTheIconOfYourPreferredChatAppAndSendUsYourInquiry')}
                  </div>
                </NumberWrap>
              </NubmerSection>
            </InfoWrap>
          </RightSection>
        </TopSection>
        <LibraryWrap>
          <LibraryTitle>
            <img src={Images.LibraryIcon} alt="customer-center-library-icon" />
            <div>{t('megagenDigitalLibrary')}</div>
          </LibraryTitle>
          <LibraryDesc>
            <MultiLineText
              translationKey={t('theLatestMegagenImplantLibraryIsAvailable')}
            />
          </LibraryDesc>
          <ButtonWrap>
            <LibraryButton
              as="a"
              href="https://r2gate.com/cad-cam?cate=3shape"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>Digital Library</div>
              <img src={Images.NavigateArrowImg} alt="library-navigate-arrow" />
            </LibraryButton>
          </ButtonWrap>
        </LibraryWrap>
      </ContentsSection>
    </Container>
  );
};

export default CustomerCenterPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  gap: 38.5px;
  padding: 50.5px 0 0 13px;
`;

const TopSection = styled.div`
  display: flex;
  gap: 55px;
`;

const ContentsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 51px;
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const RightSection = styled.div`
  background: #f4f5fc;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 20px;
  height: 246px;
  width: 460px;
  box-sizing: border-box;
`;

const QRCodeImg = styled.img`
  height: 214px;
`;

const InfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Desc = styled.div`
  font-size: 15px;
  line-height: 160%;
  color: #212767;
  text-align: left;
`;

const NubmerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NumImg = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 4px;
`;

const NumberWrap = styled.div`
  font-size: 15px;
  line-height: 160%;
  display: flex;
  gap: 4px;
  color: #151131;
  text-align: left;
`;

const LibraryWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 460px;
  box-sizing: border-box;
  padding: 20px 24px;
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    rgba(234, 100, 236, 0.1) 37%,
    rgba(255, 255, 255, 0.1) 86%
  );
`;

const LibraryTitle = styled.div`
  display: flex;
  gap: 8px;
  font-family: ${fonts.family.poppins};
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 140%;
  color: #151131;
`;

const LibraryDesc = styled.div`
  font-size: 15px;
  line-height: 160%;
  color: #151131;
  text-align: start;
  margin: 8px 16px 16px;
`;

const ButtonWrap = styled.div`
  display: flex;
  justify-content: end;
`;

const LibraryButton = styled.a`
  border-radius: 999px;
  background: #ffffff;
  box-shadow: -1px 1px 8px rgba(169, 28, 34, 0.2);
  width: 165px;
  height: 40px;
  font-family: ${fonts.family.poppins};
  font-weight: ${fonts.weight.semiBold};
  font-size: 14px;
  line-height: 130%;
  color: #a91c22;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  &:hover {
    background: #f9e4e5;
    color: #a91c22;
  }
`;
